import axios from "@/api/client";

const state = {
  healthEntries: null,
  healthEntry: null,
};

const getters = {
  stateHealthEntries: (state) => state.healthEntries,
  stateHealthEntry: (state) => state.healthEntry,
};

const actions = {
  // returns only for logged-in user (like your /stocks)
  async getHealthEntries({ commit }) {
    console.log("<-<-<-<-<>>>health.js: getHealthEntries:");
    let { data } = await axios.get("health"); // GET /health
    commit("setHealthEntries", data);
  },

  async viewHealthEntry({ commit }, calendarDate) {
    console.log("health.js: viewHealthEntry:", calendarDate);
    let { data } = await axios.get(`health/${calendarDate}`); // GET /health/2025-12-19
    commit("setHealthEntry", data);
  },

  async getHealthRange({ commit }, payload) {
    // payload: { fromDate: "2025-12-01", toDate: "2025-12-31" }
    console.log("health.js: getHealthRange:", payload);
    let { data } = await axios.get(
      `health/range/${payload.fromDate}/${payload.toDate}`
    );
    commit("setHealthEntries", data);
    return data;
  },
  async downloadLlmSummaryRange(_, payload) {
    console.log("health.js: downloadLlmSummaryRange", payload)

    const resp = await axios.get(
      `health/llm-summary/range/${payload.fromDate}/${payload.toDate}`,
      { responseType: "blob" }
    )

    const blob = new Blob([resp.data], { type: "application/json" })
    const url = window.URL.createObjectURL(blob)

    const a = document.createElement("a")
    a.href = url
    a.download = `llm_summary_${payload.fromDate}_${payload.toDate}.json`
    document.body.appendChild(a)
    a.click()
    a.remove()
  },


};

const mutations = {
  setHealthEntries(state, items) {
    state.healthEntries = items;
  },
  setHealthEntry(state, item) {
    state.healthEntry = item;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
